/* T1 — Entrada.
 *
 * A única tela sem sessão, e por isso a mais atacada. O que a protege está no
 * servidor (mensagem única para qualquer falha, tempo constante mesmo sem
 * usuário, bloqueio temporário da conta). Aqui a regra é não estragar isso:
 *
 *   * **A mensagem de erro é a que o servidor mandou**, sem reescrita. Se a
 *     tela dissesse "e-mail não encontrado" a partir de um 401 genérico, ela
 *     entregaria de graça a lista de contas válidas que o servidor esconde.
 *   * **Não existe cadastro aberto.** Contas nascem em T5, junto com as
 *     empresas que a pessoa pode acessar.
 */

import React, { useState } from 'react';

import { Botao, Caixa, Campo, Icone } from '../ds/componentes';
import { aoDigitar, aoMarcar } from '../ds/eventos';
import { useSessao } from '../estado/sessao';

export default function Entrada() {
  const { entrar } = useSessao();

  const [email, definirEmail] = useState('');
  const [senha, definirSenha] = useState('');
  const [manterConectado, definirManterConectado] = useState(false);
  const [erro, definirErro] = useState(null);
  const [enviando, definirEnviando] = useState(false);

  async function submeter(evento) {
    evento.preventDefault();

    if (!email.trim() || !senha) {
      definirErro('Informe e-mail e senha.');
      return;
    }

    definirEnviando(true);
    definirErro(null);

    try {
      await entrar(email.trim(), senha);
    } catch (falha) {
      definirErro(falha.mensagem);
      definirSenha('');
    } finally {
      definirEnviando(false);
    }
  }

  return (
    <div
      style={{
        flex: 1,
        minHeight: 0,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: 24,
        background: 'var(--superficie-base)',
        overflow: 'auto',
      }}
    >
      <div style={{ width: '100%', maxWidth: 400, display: 'flex', flexDirection: 'column', gap: 24 }}>
        <div style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
          <span
            style={{
              font: '600 20px/26px var(--fonte-interface)',
              letterSpacing: '-.012em',
              color: 'var(--texto-primario)',
            }}
          >
            Painel
          </span>
          <span
            style={{
              font: 'var(--texto-corpo-denso)',
              color: 'var(--texto-terciario)',
              textWrap: 'pretty',
            }}
          >
            Este painel expõe conversas de clientes. Entre com a conta criada pelo
            administrador da sua empresa.
          </span>
        </div>

        <form
          onSubmit={submeter}
          style={{
            display: 'flex',
            flexDirection: 'column',
            gap: 16,
            padding: 24,
            background: 'var(--superficie-elevada)',
            border: '1px solid var(--borda-sutil)',
            borderRadius: 'var(--raio-md)',
            boxShadow: 'var(--elev-1)',
          }}
        >
          {erro && (
            <div
              role="alert"
              style={{
                display: 'flex',
                gap: 8,
                padding: '10px 12px',
                background: 'var(--erro-superficie)',
                border: '1px solid var(--erro-borda)',
                borderRadius: 'var(--raio-sm)',
                font: 'var(--texto-corpo-denso)',
                color: 'var(--erro-texto)',
                textWrap: 'pretty',
              }}
            >
              <Icone nome="circle-alert" tamanho={15} />
              <span>{erro}</span>
            </div>
          )}

          <Campo
            rotulo="E-mail de trabalho"
            tipo="email"
            icone="mail"
            placeholder="voce@empresa.com.br"
            valor={email}
            aoMudar={aoDigitar(definirEmail)}
            obrigatorio
            autoComplete="username"
            autoFocus
          />

          <Campo
            rotulo="Senha"
            tipo="password"
            icone="lock"
            valor={senha}
            aoMudar={aoDigitar(definirSenha)}
            obrigatorio
            autoComplete="current-password"
          />

          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 12 }}>
            <Caixa
              rotulo="Manter conectado neste computador"
              marcado={manterConectado}
              aoMudar={aoMarcar(definirManterConectado)}
            />
          </div>

          <Botao variante="primario" larguraTotal carregando={enviando} tipo="submit">
            Entrar no painel
          </Botao>
        </form>

        <p style={{ margin: 0, font: 'var(--texto-legenda)', color: 'var(--texto-terciario)', textWrap: 'pretty' }}>
          Não existe cadastro aberto. Contas são criadas pelo administrador em{' '}
          <strong style={{ fontWeight: 'var(--peso-medio)' }}>Empresas e assistentes</strong>, junto
          com as empresas que a pessoa pode acessar.
        </p>
      </div>
    </div>
  );
}
